import { useEffect } from 'react';
import { useHistory } from 'umi';
// import { useLatest } from 'ahooks';
import useFilterExtend from '@intelligence/hooks/useFilterExtend';

const MOBILE_GAMES_TOP_CHARTS_PREFIX = '/intelligence/topCharts/mobileGames';

/**
 * mobileGames 榜单 tab 之间切换时保留筛选器继承状态（不含游戏详情页）
 */
const isMobileGamesTopChartsTab = (pathname: string): boolean => {
  if (!pathname.startsWith(MOBILE_GAMES_TOP_CHARTS_PREFIX)) {
    return false;
  }
  if (pathname.includes('/gamesDetails/')) {
    return false;
  }
  return true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useCheckedGenresClear(fetchParams?: any) {
  const history = useHistory();

  const { resetFilterExtend } = useFilterExtend({});

  // const fetchParamsLatest = useLatest(fetchParams);

  useEffect(() => {
    const unListen = history.listen((location) => {
      const { pathname } = location || {};
      if (isMobileGamesTopChartsTab(pathname)) return;
      // if (fetchParamsLatest.current?.genre_source === 'sensortower') {
      //   resetFilterExtend();
      // }
      resetFilterExtend();
    });

    // 清理监听器
    return () => {
      unListen();
    };
  }, []);
}
